import { createSelector } from 'reselect';

const selectCrmcontacts = (state: any) => state.crmcontacts;


export const selectCrmcontactsCurrentItem = createSelector([selectCrmcontacts], (crmcontacts) => crmcontacts.current);

export const selectCrmcontactsListItems = createSelector([selectCrmcontacts], (crmcontacts) => crmcontacts.list);

export const selectCrmcontactsItemById = (itemId: any) =>
    createSelector(selectCrmcontactsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCrmcontactsQueryItems = createSelector([selectCrmcontacts], (crmcontacts) => crmcontacts.query);

export const selectCrmcontactsCreatedItem = createSelector([selectCrmcontacts], (crmcontacts) => crmcontacts.create);

export const selectCrmcontactsUpdatedItem = createSelector([selectCrmcontacts], (crmcontacts) => crmcontacts.update);

export const selectCrmcontactsReadItem = createSelector([selectCrmcontacts], (crmcontacts) => crmcontacts.read);

export const selectCrmcontactsDeletedItem = createSelector([selectCrmcontacts], (crmcontacts) => crmcontacts.delete);

export const selectCrmcontactsSearchedItems = createSelector([selectCrmcontacts], (crmcontacts) => crmcontacts.search);

export const selectCrmcontactsItemsCount = createSelector([selectCrmcontacts], (crmcontacts) => crmcontacts.count);

export const selectCrmcontactsItemsFilter = createSelector([selectCrmcontacts], (crmcontacts) => crmcontacts.filter);